"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../container"));
var global_1 = require("../selectors/global");
var fetchGenerationLastUpdated_1 = __importDefault(require("../actions/generation/fetchGenerationLastUpdated"));
var point_1 = require("../selectors/point");
var generation_1 = require("../selectors/generation");
function fetchGenerationSettingsSchedule(dispatch, getState) {
    var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/fetchGenerationSettingsSchedule");
    var state = getState();
    var lastFetch = (0, generation_1.selectLastGenerationSettingsFetch)(state);
    var lastFetched = Date.now() - lastFetch;
    if (lastFetched < 10000) {
        return;
    }
    if (!(0, global_1.selectIsConnected)(state)) {
        logger.debug("No internet connection, skip");
        return;
    }
    var hasPoint = !!(0, point_1.selectCurrentPointId)(state);
    if (!hasPoint) {
        logger.debug("No point available, skip");
        return;
    }
    if ((0, generation_1.selectGenerationSettingsAreFetching)(state)) {
        logger.warn("Action already in progress, skip...");
        logger.debug("Generation fetch metadata", __assign({}, state.generation.metadata));
        return;
    }
    dispatch((0, fetchGenerationLastUpdated_1.default)());
}
exports.default = fetchGenerationSettingsSchedule;
//# sourceMappingURL=fetchGenerationSettings.js.map